export const AUTH_SOURCE_IMLP = 'IMLP';
export const AUTH_SOURCE_IMLP2 = 'IMLP2';
export const AUTH_SOURCE_ILAUTH = 'ILAuth';
export const AUTH_SOURCE_SESSION_KEY = 'oidc.authSource';



// WEBPACK FOOTER //
// ./src/constants/authSources.js